import { MatchStatus, TournamentShortDto } from "../stats";

export enum MathcEventType {
    Goal = 'goal',
    YellowCard = 'yelowCard',
    RedCard = 'redCard',
    SubstitutionIn = 'substitutionIn',
    SubstitutionOut = 'substitutionOut',
    PenaltyGoal = 'penaltyGoal',
    AutoGoal = 'autoGoal',
    MissedPenalty = 'missedPenalty',
}

export interface MatchEventShort {
    eventType: MathcEventType;
    time: number;
}

export interface MatchEvent extends MatchEventShort {
    player1: PlayerInfoShort;
    player2?: PlayerInfoShort;
}

export interface PlayerInfoShort {
    teamId: number;
    id: number;
    name: string;
    photoUrl?: string;
    url?: string;
}

export interface PlayerInfo extends PlayerInfoShort {
    isGK?: boolean;
    isCaptain?: boolean;
    events?: MatchEventShort[];
    isSub?: boolean;
}

export interface CoachInfo extends PlayerInfoShort {
    position: string;
}

export interface TeamMainInfo {
    id: number;
    logo: string;
    name: string;
    city?: string;
}

export interface MatchState {
    score: string;
    halfTimeScore?: string;
    players: PlayerInfo[];
    coaches: CoachInfo[];
    goals: GoalInfo[];
    penalties?: PenaltyKick[];
    events?: MatchEvent[];
}

export interface MatchLinks {
    reportUrl?: string;
    videoUrl?: string;
    textLiveUrl?: string;
    reviewUrl?: string;
    ticketUrl?: string;
}

export interface MatchInfoShort {
    id: number;
    date: string;
    preliminaryDate?:boolean;
    homeTeam: TeamMainInfo;
    guestTeam: TeamMainInfo;
    links?: MatchLinks;
    score: string;
    tournament?: TournamentShortDto;
    status: MatchStatus;
}

export interface MatchInfo extends Omit<MatchInfoShort, 'score' | 'id'> {
    season: string;
    place?: string;
    state: MatchState;
}

export interface PenaltyKick {
    teamId: number;
    player: PlayerInfo;
    missed?: boolean;
}

export enum GoalType {
    Regular = 'regular',
    Penalty = 'penalty',
    MissedPenalty = 'missedPenalty',
    Auto = 'auto',
}

export interface GoalInfo {
    teamId: number;
    time: number;
    player: PlayerInfoShort;
    assist?: PlayerInfoShort;
    type: GoalType;
}
